import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-content px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-xl border border-primary-800 bg-primary-950">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20stylized%20dark%20background%20with%20layered%20warning%20panel%20shapes%20and%20soft%20glowing%20amber%20lines%2C%20deep%20warm%20charcoal%20and%20burnt%20orange%20palette%2C%20minimal%20geometric%20editorial%20design%2C%20no%20text%2C%20no%20letters&width=1600&height=700&seq=home-cta-banner-2026&orientation=landscape"
          alt="提交风险线索引导背景"
          title="提交网站黑料线索 - 避雷哨"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/75 to-primary-950/55" />
        <div className="relative px-6 py-9 md:px-12 md:py-14">
          <h2 className="max-w-2xl font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">
            发现可疑平台？把你踩过的坑，变成别人的避雷提醒
          </h2>
          <p className="mt-3 max-w-xl font-body text-sm leading-relaxed text-primary-100 md:text-base">
            一条真实的反馈，可能帮到很多还在犹豫的人。提交后我们会核实、去重，并按风险等级整理收录。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
            >
              <i className="ri-add-circle-line text-base" />
              提交风险线索
            </Link>
            <Link
              to="/blacklist"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300/70 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-900 cursor-pointer"
            >
              <i className="ri-list-check-2 text-base" />
              浏览避雷名单
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}